export enum AccordionContentBlock {
  Root = 'AccordionContent',
}

export enum AccordionContentModifiers {
  Open = 'open',
  Close = 'close',
}
